import { FETCH_BULK_CAMPAIGNS_SUCCESS } from './actionTypes';

export const fetchBulkCampaignsSuccess = campaigns => ({ type: FETCH_BULK_CAMPAIGNS_SUCCESS, payload: campaigns });
